export default __webpack_public_path__ + "static/media/pt-logo-single.5462d59f.svg";